<template>
  <div style="text-align: left; display: flex; flex-direction: column; justify-content: center; align-items: center;">
    
        <el-table
            v-if="!$store.state.preferences.props.horizontal_style_sheet"
            :data="getStyleList"
            style="width: 100%">
          <el-table-column 
            prop="style_name"
            label="Styling Name">
          </el-table-column>
          <el-table-column           
              label="Instructions" align="center">
              <template slot-scope="scope">
                  <span v-if="scope.row.edited_option.length>0">
                    {{scope.row.edited_option}}
                  </span>
                  <span v-else>
                    {{scope.row.option_detail.option_name}}
                  </span>
              </template>
          </el-table-column>
          <el-table-column           
              label="Charges" align="center">
              <template slot-scope="scope">
                  <span>
                    {{scope.row.extra_charge>0 ? formatCurrency(parseFloat(scope.row.extra_charge)*parseFloat(scope.row.qty))+' For '+scope.row.extra_charge_notes : '-'}}
                  </span>
              </template>
          </el-table-column>
          <el-table-column 
              label="Options" align="center">
              <template slot-scope="scope">
                  <el-button @click="openOptionPopup(scope.row.key)" size="small" icon="el-icon-s-grid"></el-button>
              </template>
          </el-table-column>
        </el-table>

        <div v-else style="display: flex; flex-direction: row; flex-wrap: wrap; width: 100%;">

                <div 
                    v-for="(data, index) in getStyleList" 
                    :key="index" style="margin: 10px;">

                        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 200px;">

                            <span>
                              <b>{{data.style_name}}</b>
                            </span>                            
                            <span>
                              {{data.option_detail.option_name}}
                            </span>
                            <span>
                              {{data.extra_charge>0 ? formatCurrency(parseFloat(data.extra_charge)*parseFloat(data.qty))+' For '+data.extra_charge_notes : '-'}}
                            </span>
                            <el-button @click="openOptionPopup(data.key)" size="small" icon="el-icon-s-grid"></el-button>
                        </div>

                </div>

        </div>

        <el-dialog
          :title="getOptionWindowTitle"
          :visible.sync="showOptionWindow"
          width="70%" 
          style="text-align: left;"
          append-to-body>
          <StyleListOption :parentKey="getParentKey" :style_list="getStyleList" @close="showOptionWindow=false"/>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" size="small" @click="showOptionWindow = false">Close</el-button>
          </span>

        </el-dialog>

  </div>
</template>

<script>
import StyleListOption from './StyleListOption.vue'

export default {
    props: ['style_list'],
    components: {StyleListOption},
    data() {
      return {
        showOptionWindow: false,
        parentKey: -1
      }
    },
    computed: {
      getParentKey() {
        return this.parentKey
      },
      getOptionWindowTitle() {
          if(this.getParentKey >=0) {
            return this.getStyleList[this.getParentKey].style_name+' Options'
          }
          return "Error"
      },
      getStyleList() {
        let styleList = []

        let key = 0
        this.style_list.forEach(element => {
          element.key = key
          styleList.push(element)
          key ++
        })
        return styleList
      }
    },
    methods: {
      openOptionPopup(parentKey) {
      
          this.parentKey = parentKey
          
          setTimeout(() => {
            this.showOptionWindow = true             
          }, 100);

          
      }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/WorkOrder/StyleList.vue